import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { WIDGET_SIZES } from '@liveHelper/components/shared/WidgetContainer/WidgetContainer.styles'
import { Z_INDEX } from '@liveHelper/constants'
import {
  ActionButton,
  FadeInAnimation,
  Transition,
  TRANSITION_TIMING_FUNCTION,
} from '@oneToOne/shared/styles'

import { Image } from '@core/components/Image'
import { UnstyledButton } from '@core/components/twind/Button'

const idleMinimizedTiming = '0.6s'

export const FoldedText = styled.span`
  ${FadeInAnimation}
  padding: var(--spacing-4);
  color: var(--white);
  font-weight: var(--font-semibold);
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  width: 100%;
  text-align: center;
`

export const AgentImage = styled(Image)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top;
`

export const AgentImageFallback = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 43%;
  font-size: var(--font-size-lg);
  color: var(--white);
  text-align: center;
  width: 200px;
  overflow: hidden;
  word-break: break-all;
  margin: 0 auto;
`

export const FoldedTextWrapper = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  height: auto;
  padding-top: var(--spacing-12);
  width: 100%;
  background: linear-gradient(
    180deg,
    rgb(0 0 0 / 0%) 0%,
    rgb(0 0 0 / 80%) 100%
  );
`

export const IdleFoldedAnimatedContainer = styled(UnstyledButton, {
  shouldForwardProp: (prop) => prop !== 'hasLastUnreadMessage',
})<{
  hasLastUnreadMessage: boolean
}>`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  flex-grow: 1;
  height: ${(props) =>
    props.hasLastUnreadMessage
      ? WIDGET_SIZES.minimized.avatar.height
      : WIDGET_SIZES.minimized.default.height};
  width: ${(props) =>
    props.hasLastUnreadMessage
      ? WIDGET_SIZES.minimized.avatar.width
      : WIDGET_SIZES.minimized.default.width};
  cursor: pointer;
  border-radius: ${({ hasLastUnreadMessage }) =>
    hasLastUnreadMessage ? '50%' : 'var(--border-radius-md)'};
  box-shadow: var(--box-shadow);
`

export const AgentImageContainer = styled.div<{
  hasLastUnreadMessage: boolean
}>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: ${({ hasLastUnreadMessage }) =>
    hasLastUnreadMessage ? '50%' : 'var(--border-radius-md)'};
`

const FadeOut = css`
  animation-name: fadeOut;
  animation-duration: ${idleMinimizedTiming};
  animation-timing-function: ${TRANSITION_TIMING_FUNCTION};
  animation-fill-mode: forwards;
  opacity: 1;

  @keyframes fadeOut {
    to {
      opacity: 0;
    }
  }
`

export const GreenDot = styled.div<{ isHiding: boolean }>`
  position: absolute;
  bottom: 0;
  right: 0;
  background-color: var(--green);
  border-radius: 50%;
  height: 18px;
  width: 18px;
  border: 2px solid var(--white);
  ${({ isHiding }) => isHiding && FadeOut}
`

export const MultiAgentContainer = styled.button`
  ${Transition}
  ${FadeInAnimation}
  position: relative;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  flex-direction: column;
  background-color: transparent;
  border-width: 0;
  outline: none;
  &:focus {
    outline: none;
  }
`

export const CloseWidgetButton = styled(ActionButton)<{ isAvatarUI?: boolean }>`
  position: absolute;
  ${({ isAvatarUI = false }) => {
    const offset = isAvatarUI ? '-8px' : '-11px'
    return `
      top: ${offset};
      inset-inline-end: ${offset};
    `
  }}
  z-index: ${Z_INDEX.FLOATING_ACTION};
  color: var(--white);
`
